// extracted by mini-css-extract-plugin
module.exports = {"container":"AiMemeCard_container__Yp9oP","title":"AiMemeCard_title__yLQYY","subTitle":"AiMemeCard_subTitle__U4UFb","btn":"AiMemeCard_btn__avWYE","num":"AiMemeCard_num__loOLL"};